// extracted by mini-css-extract-plugin
export default {"pageRoot":"OffsiteSuppliersPage_pageRoot__PdrA5","pageContent":"OffsiteSuppliersPage_pageContent__bjGGg"};